import { Locale } from '../../i18n/types';
import { BrandHighlight } from '../BrandHighlight';

interface Props {
  why: Locale['why'];
  science: Locale['science'];
}

export default function ScienceCombinedTab({ why, science }: Props) {
  return (
    <div>
      <div className="mb-5">
        <div className="d-flex flex-column gap-4">
          {why.map((p) => (
            <div key={p.title}>
              <div className="text-white fw-semibold mb-1 section-title">
                {p.title}
              </div>
              <p className="text-body">
                <BrandHighlight text={p.desc} />
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="p-3 rounded info-box-primary">
        <p className="mb-0 text-white text-sm-compact" style={{ fontStyle: 'italic' }}>
          <i className="bi bi-info-circle-fill me-2 text-primary"></i>
          {science.loginRequired}
        </p>
      </div>
    </div>
  );
}
